import React, { useState } from 'react'
import ModalConfirmarCrearCuentasFormasDeLiquidacion from './ModalConfirmarCrearCuentasFormasDeLiquidacion'
import { postModificarCuentasFormasLiquidacion } from '../../../services/Contratacion'

const ModalModificarCuentasFormasDeLiquidacion = ({setmodalOnModificarCuentas,dataModificarCuentas,setactualizaDataCuentas}) => {    
    const [errorSeleccionarCuentaContable, seterrorSeleccionarCuentaContable]=useState('')
    const [errorSeleccionarCuentaCosto, seterrorSeleccionarCuentaCosto]=useState('')
    const [mesanjeCrearCuentasFormasDeLiquidacion, setmesanjeCrearCuentasFormasDeLiquidacion]=useState('')
    const [modalOnMensajeCrearCuentasFormasDeLiquidacion,setmodalOnMensajeCrearCuentasFormasDeLiquidacion]=useState(false)
    const [loading, setloading]=useState(false)

    const handleCancelarClick=()=>{
        setmodalOnModificarCuentas(false)
    }

    const handleOnchangeCuentaContable=(e)=>{
        if(e.target.value){
            seterrorSeleccionarCuentaContable('')
        }else{
            seterrorSeleccionarCuentaContable('Seleccionar Cuenta Contable')
        }
    }

    const handleOnchangeCuentaCosto=(e)=>{
        if(e.target.value.trim()){
            seterrorSeleccionarCuentaCosto('')
        }else{
            seterrorSeleccionarCuentaCosto('Seleccionar cuenta costo')
        }
    }

    const handleOnsubmitCrearCuenta=(e)=>{
        e.preventDefault()
        if( errorSeleccionarCuentaContable === '' && errorSeleccionarCuentaCosto === ''){
            const guardar={
                "EMPCOD": e.target.empresa.value,
                "CntVig": e.target.vigencia.value,
                "CntCod": e.target.cuentaContable.value,
                "ForLiqCod":dataModificarCuentas.ForLiqCod,
                "HnrCod":dataModificarCuentas.HnrCod,
                "ForCntCos": e.target.cuentaCosto.value
            }
            setloading(true)
            console.log(guardar,'guardar')
            postModificarCuentasFormasLiquidacion(guardar).then((res)=>{
               setloading(false)
                if(res.data.success){
                    setmodalOnModificarCuentas(false)
                    setactualizaDataCuentas(guardar) 
                }else{
                   setmesanjeCrearCuentasFormasDeLiquidacion(res.data.message)
                   setmodalOnMensajeCrearCuentasFormasDeLiquidacion(true)
                 }
            })            
        }
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-2xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Modificar Formas Liquidación Cuentas
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            <form onSubmit={handleOnsubmitCrearCuenta}>
              <div className="flex  text-left">
                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Vigencia
                  </label>
                  
                  <input
                    defaultValue={dataModificarCuentas.ForLqVig}
                    disabled={true}                    
                    name='vigencia'
                    type="number"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                    
                  </div>
                  <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Empresa
                  </label>                  
                  <input                    
                    defaultValue={dataModificarCuentas.ForLqEmp}
                    disabled={true}
                    name='empresa'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />                  
                  </div>                  
              </div>
              <div className="flex  text-left">                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Cuenta contable
                  </label>                  
                  <input
                    onChange={handleOnchangeCuentaContable}
                    defaultValue={dataModificarCuentas.ForCntUVR}
                    name='cuentaContable'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarCuentaContable}
                  </label>                    
                  </div>
                  <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Cuenta Costo
                  </label>                  
                  <input
                    onChange={handleOnchangeCuentaCosto}
                    defaultValue={dataModificarCuentas.ForCntCos}
                    name='cuentaCosto'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarCuentaCosto}
                  </label>
                  </div>
                  
              </div>           
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div>
          </form>
          </div>
        </div>
      </div>
      {loading &&
      <div className="relative flex items-center justify-center h-screen">
      <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
          <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
              <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
              <p className="mt-4 text-lg">Cargando</p>
          </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
  </div>}
      
      {modalOnMensajeCrearCuentasFormasDeLiquidacion? <ModalConfirmarCrearCuentasFormasDeLiquidacion setmodalOnMensajeCrearCuentasFormasDeLiquidacion={setmodalOnMensajeCrearCuentasFormasDeLiquidacion} mesanjeCrearCuentasFormasDeLiquidacion={mesanjeCrearCuentasFormasDeLiquidacion}/>:null}
    </div>
  )
}

export default ModalModificarCuentasFormasDeLiquidacion